import type { PacingState } from "../hooks/useInterviewPacing.ts";

/** Live pacing/coaching cue. Renders nothing when there's no active alert. */
export function PacingBanner({ pacing }: { pacing: PacingState }) {
  if (!pacing.alert) return null;
  const warn = pacing.alert.level === "warn";
  return (
    <div
      style={{
        margin: "12px 20px",
        padding: "10px 14px",
        borderRadius: 8,
        fontSize: 13,
        background: warn ? "rgba(249,171,0,.12)" : "rgba(26,115,232,.10)",
        border: `1px solid ${warn ? "#f9ab00" : "#1a73e8"}`,
        color: "var(--text-1)",
      }}
    >
      {warn ? "⏱ " : "ℹ "}
      {pacing.alert.text}
    </div>
  );
}
